const CheckIcon = ({
  width = 15,
  height = 11,
  color = "white",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M14.3438 1.34375L5.84375 9.84375C5.71875 10 5.53125 10.0625 5.34375 10.0625C5.125 10.0625 4.9375 10 4.8125 9.84375L0.3125 5.34375C0 5.0625 0 4.59375 0.3125 4.3125C0.59375 4 1.0625 4 1.34375 4.3125L5.34375 8.28125L13.3125 0.3125C13.5938 0 14.0625 0 14.3438 0.3125C14.6562 0.59375 14.6562 1.0625 14.3438 1.34375Z"
        fill={color}
      />
    </svg>
  );
};

export default CheckIcon;
